module.exports = __webpack_public_path__ + "../resources/img/weather_wind.5c8c0d0e.svg";